import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full overflow-hidden bg-brandBg" }
const _hoisted_2 = { class: "flex flex-col w-0 flex-1 overflow-hidden" }
const _hoisted_3 = { class: "flex-1 relative overflow-y-auto focus:outline-none" }
const _hoisted_4 = { class: "flex flex-col justify-between" }
const _hoisted_5 = { class: "flex-1" }

import {
		ref,
		onMounted,
		onBeforeUnmount
	} from 'vue'

	import EventBus from '@/events'

	
export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

	const scrollingDisabled = ref(false)   
	const scrollUpCheck = ref(0)
	var initialY = 0 

	async function handleScroll(){

		const scrollBreakPoint = 1.25
		let windHeight = window.innerHeight
		let body = document.body
		let html = document.documentElement
		let totalHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html?.scrollHeight , (html.offsetHeight))

		// infinite scroll
		if((totalHeight <= (windHeight * scrollBreakPoint) + window.scrollY) && !scrollingDisabled.value){
			scrollingDisabled.value = true
			EventBus.trigger('infinite-scroll', null)
		}
		else if((windHeight + window.scrollY) < scrollUpCheck.value){
			EventBus.trigger('scroll-up' , null)
		}
		scrollUpCheck.value = windHeight + window.scrollY
	}
	onMounted(() => {
		window.USGA.addNavigation()
		document.addEventListener('scroll', () => {
			handleScroll()
		}, {
			capture: true,
			passive: true
		})

		EventBus.on('infinite-scroll-end', () =>{
			scrollingDisabled.value = false
		})
		
	})

	onBeforeUnmount(() => {
		document.removeEventListener('scroll', handleScroll)
		EventBus.off('infinite-scroll-end', null)
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})